import get from 'lodash.get';
import { defaultDateFormatterOptions, defaultRelativeFormatterOptions } from './defaults.js';
import { NullLogger } from '@fds/wm-typescript-logger';

const MS_IN_SECOND = 1e3;
const SECONDS_IN_MINUTE = 60;
const MINUTES_IN_HOUR = 60;
const HOURS_IN_DAY = 24;
class DateFormatter {
  constructor(configuration) {
    var _a, _b, _c;
    this.dateFormatOptions = {
      ...defaultDateFormatterOptions,
      ...(_a = configuration == null ? void 0 : configuration.options) == null ? void 0 : _a.date
    };
    this.relativeTimeFormatOptions = {
      ...defaultRelativeFormatterOptions,
      ...(_b = configuration == null ? void 0 : configuration.options) == null ? void 0 : _b.relativeTime
    };
    this.logger = (_c = configuration == null ? void 0 : configuration.logger) != null ? _c : new NullLogger();
    this.logger.debug(`${this.constructor.name} initialized with:`, {
      dateFormatOptions: this.dateFormatOptions,
      relativeTimeFormatOptions: this.relativeTimeFormatOptions
    });
  }
  format(date, options) {
    if ((options == null ? void 0 : options.locale) === void 0) {
      return date.toString();
    }
    const formatterOptions = this.getDateFormatOptions(options.format);
    try {
      return date.toLocaleString(options.locale, formatterOptions);
    } catch (e) {
      this.logger.error("IntlDateFormatter: ", e);
      return date.toString();
    }
  }
  formatRelative(date, options) {
    if ((options == null ? void 0 : options.locale) === void 0) {
      return date.toString();
    }
    const formatterOptions = this.getRelativeTimeFormatOptions(options.format);
    try {
      const relativeTimeFormat = new Intl.RelativeTimeFormat(options.locale, formatterOptions);
      const differenceInMs = date.getTime() - Date.now();
      const seconds = Math.floor(differenceInMs / MS_IN_SECOND);
      if (Math.abs(seconds) <= SECONDS_IN_MINUTE) {
        return relativeTimeFormat.format(seconds, "seconds");
      }
      const minutes = Math.floor(seconds / SECONDS_IN_MINUTE);
      if (Math.abs(minutes) <= MINUTES_IN_HOUR) {
        return relativeTimeFormat.format(minutes, "minute");
      }
      const hours = Math.floor(minutes / MINUTES_IN_HOUR);
      if (Math.abs(hours) <= HOURS_IN_DAY) {
        return relativeTimeFormat.format(hours, "hour");
      }
      const days = Math.floor(hours / HOURS_IN_DAY);
      return relativeTimeFormat.format(days, "days");
    } catch (e) {
      this.logger.error("IntlRelativeTimeFormatter: ", e);
      return date.toString();
    }
  }
  getDateFormatOptions(format) {
    var _a;
    return get(this.dateFormatOptions, format != null ? format : "default", (_a = this.dateFormatOptions.default) != null ? _a : {});
  }
  getRelativeTimeFormatOptions(format) {
    var _a;
    return get(this.relativeTimeFormatOptions, format != null ? format : "long", (_a = this.relativeTimeFormatOptions.long) != null ? _a : {});
  }
}

export { DateFormatter };
